import type { UserProfile } from "@common/types/user";

export const deeplinkProtocol = "twoday"; // i.e. twoday://

export function makeDeeplink(profile: UserProfile | null, accessToken: string | null) {
  if (!accessToken || !profile) return null;
  const { createdDate, isPremium /*TODO: refresh after deeplink*/, seenOnboarding, isWaitlisted, ...profileData } =
    profile;
  const urlParams = {
    ...profileData,
    createdDate: `${createdDate ?? new Date().valueOf()}`,
    token: accessToken,
  };

  return `${deeplinkProtocol}://?${new URLSearchParams(urlParams).toString()}`;
}
